// extracted by mini-css-extract-plugin
export default {"header":"OffRampLinkDetails_header__nAy+q","codeDisplay":"OffRampLinkDetails_codeDisplay__hfOAq"};